export default __webpack_public_path__ + "static/media/790245980175466526.d4fb29bb.png";